import { Flex, ListItem, UnorderedList } from '@chakra-ui/react'

const IdaReportsPageBanner = ({ mb }: { mb?: string }) => {
  return (
    <Flex
      m='1.5rem'
      mb='0'
      p='12px'
      flexDir={'column'}
      bg='gray.50'
      border='1px solid'
      borderColor='gray3'
      borderRadius='8px'
      fontSize='12px'
      gap='8px'
      lineHeight={1.6}
    >
      The IDA product includes two types of monthly reports:{' '}
      <UnorderedList styleType='lower-roman' ml='2rem'>
        <ListItem mb='4px'>
          <b>ID Analytics and Insights Report: </b> This detailed report
          highlights the most significant developments in the infectious disease
          countermeasures space. It examines these developments through
          competitive intelligence, commercial, and epidemiological lenses -
          giving you clear, actionable insights and the essential "so what"
          behind each development.
        </ListItem>
        <ListItem mb='4px'>
          <b>
            Serious Bacterial Infections and Antimicrobial Resistance
            Reports:{' '}
          </b>
          These reports cover the latest pipeline developments, news, and
          epidemiology for three high priority serious bacterial infections:{' '}
          <i>
            <b>
              Staphylococcus aureus, Klebsiella pneumoniae and Clostridium
              difficile.
            </b>{' '}
          </i>
          If your interests extend beyond these serious bacterial infections and
          you would like dedicated insights, please get in touch with your
          account manager or <b>infectiousdiseases@airfinity.com</b> to discuss
          how we can best support you.
        </ListItem>
      </UnorderedList>
    </Flex>
  )
}

export default IdaReportsPageBanner
